const enum ApiStatus {
  NONE,
  LOADING,
  SUCCESS,
  ERROR,
}

const enum HttpHeaderKey {
  ContentType = "Content-Type",
  ActivePodId = "Active-Pod-Id",
  Authorization = "Authorization",
  ConsistencyLevel = "ConsistencyLevel",
  Tenant = "Tenant",
  Locale = "locale",
}

const enum HttpStatusCode {
  Success = 200,
  BadRequest = 400,
  Unauthorized = 401,
  Forbidden = 403,
  NotFound = 404,
  Conflict = 409,
  InternalServerError = 500,
}

const enum HttpErrorCode {
  Unauthorized = 401,
  Forbidden = 403,
  NotFound = 404,
  RequestTimeOut = 408,
  InternalServerError = 500,
  BadGateway = 502,
  GatewayTimeout = 504,
  Conflict = 409,
}
const enum HttpHeaderValue {
  MultipartFormData = "multipart/form-data",
  ApplicationJson = "application/json",
  Eventual = "eventual",
}
export enum HttpHeader {
  CONTENT_TYPE = "Content-Type",
  AUTHORIZATION = "Authorization",
  TENANT_ID = "TenantId",
  ACCESS_CONTROL_ALLOW_ORIGIN = "Access-Control-Allow-Origin",
}

export enum InternalErrorCode {
  InternalServerError = "Yikes! Our servers are having a bad day.\n" +
    "Something went wrong and it’s not your fault.\n" +
    "Try reloading or check back in a few minutes.",
  forbidden = "You shall not pass!\n" +
    "You don’t have the permissions to see this page.\n" +
    "Check with your admin and come back.",
  NotFound = "Oops! You’ve reached a dead end.\n" +
    "We searched everywhere and couldn’t find this page.\n" +
    "Let’s go back and look for another way.",
  RequestTimeOut = "Time’s up! The server got tired of waiting.\n" +
    "Reload the page and let’s try again.",
  Unauthorized = "Not so fast! This is a restricted area.\n" +
    "You don’t have access to this page.",
  BadGateway = "Well, that’s awkward\n" +
    "Servers’ connection seems to be a little off balance.\n" +
    "Reload this page and try again.",
  GatewayTimeout = "The gateway is running late!\n" +
    "It happens sometimes, refresh and try again.",
  Conflict = "You have an active session.\n" +
    "Please log out from other devices or sessions before proceeding.",
}

export {
  ApiStatus,
  HttpStatusCode,
  HttpHeaderKey,
  HttpHeaderValue,
  HttpErrorCode,
};
